import React from 'react';
interface PriceDisplayProps {
  amount: number;
  className?: string;
  showCurrency?: boolean;
}
function getCurrencySymbol(): string {
  if (typeof navigator === 'undefined') return '$';
  const lang = navigator.language || 'en-US';
  if (lang.startsWith('es')) return '$';
  if (lang === 'en-GB') return '£';
  if (['de', 'fr', 'it', 'nl'].some(l => lang.startsWith(l)) || lang === 'pt-PT') return '€';
  return '$';
}
export function PriceDisplay({
  amount,
  className = '',
  showCurrency = true
}: PriceDisplayProps) {
  const currency = getCurrencySymbol();
  const formattedAmount = Number.isInteger(amount) ? amount.toFixed(2) : String(amount);
  return <span className={className} data-id="element-129">
      {showCurrency && <span className="text-[0.45em] align-super" data-id="element-130">{currency}</span>}
      {formattedAmount}
    </span>;
}